import { OrgPaymentTransaction } from "./org-payment-transaction";
import {VoucherRegister} from "@app/shared/classes/voucher-register";

export class PaymentTransactionMultipleHistory {
  transaction: OrgPaymentTransaction;
  voucherRegisters: VoucherRegister[];
}
